<template>
  <div class="container" v-if="entries && entries.length > 0">
    <p class="label">
      <img :src="require('@/assets/icons/plus-blue.svg')" />
      {{ $t("general.post.dictionary.add") }}
    </p>
    <div class="subcontainer">
      <div class="dictionarylist">
        <a
          class="dictionary-item"
          v-for="entry in entries"
          :key="entry.id"
          :data-value="JSON.stringify(entry)"
          @click="selectionChanged"
          >{{ entry.title }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DictionarySelector",
  props: {
    entries: { required: true }
  },
  methods: {
    selectionChanged: function(e) {
      this.$emit("selection-changed", e);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 90%;
  margin: 16px auto;
  padding-left: 16px;
  padding-right: 16px;
  border-left: 1px solid rgb(49, 185, 190);
}

.subcontainer {
  max-height: 200px;
  overflow-y: auto;
  text-align: left;
}

.label {
  margin-bottom: 8px;
  text-align: left;

  img {
    max-width: 24px;
    max-height: 24px;
    vertical-align: middle;
  }
}

.dictionarylist {
  width: 100%;
  border: 0;

  a {
    height: 24px;
    line-height: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-family: OpenSans, sans-serif;

    &:hover,
    &:focus {
      color: #fff;
    }
  }
}
</style>
